import './MaterialsCard.scoped.scss';
import Button from 'components/Button/Button';

const MaterialsCard: React.FC = () => {
  return (
    <div className="container">
      <img
        src="https://images.pexels.com/photos/714699/pexels-photo-714699.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
        className="image"
      />
      <div className="content">
        <span className="created">Created: 01/11/2021</span>
        <h3 className="title">Chemical structures in science</h3>
        <p className="summary">
          Lorem ipsum dolor sit ametLorem ipsum metLorem ipsum dolor sit amet{' '}
        </p>
      </div>
      <Button
        onClick={() => undefined}
        round
        style={{
          background: '#5CD79E',
          color: 'white',
          fontSize: 12,
          fontWeight: 600,
          width: '50%',
          marginLeft: '0.5rem',
        }}
      >
        + Add material
      </Button>
    </div>
  );
};

export default MaterialsCard;
